// import node module libraries
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserProps {
  user_id: string;
  first_name: string;
  last_name: string;
  role: string;
  profile_img_url: string;
  username: string;
}

interface initialStateProps {
  user: UserProps;
  isUserLoading: boolean;
}

const user: UserProps = {
  user_id: "",
  first_name: "",
  last_name: "",
  role: "",
  profile_img_url: "",
  username: "",
};

const initialState = {
  user: user,
  isUserLoading: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    // Set user data
    setUser(state, action: PayloadAction<UserProps>) {
      state.user.user_id = action.payload.user_id;
      state.user.first_name = action.payload.first_name;
      state.user.last_name = action.payload.last_name;
      state.user.profile_img_url = action.payload.profile_img_url;
      state.user.role = action.payload.role;
      state.user.username = action.payload.username;
    },

    // Optionally, you can also create a clearUser reducer if you want to clear user data
    clearUser(state) {
      state.user.user_id = "";
      state.user.first_name = "";
      state.user.last_name = "";
      state.user.profile_img_url = "";
      state.user.role = "";
      state.user.username = "";
    },
    setUserLoading(state, action: PayloadAction<boolean>) {
      state.isUserLoading = action.payload;
    },
  },
});

export const { setUser, clearUser, setUserLoading } = userSlice.actions;

export default userSlice.reducer;
